import GlobalFilterForm from './component'

export default GlobalFilterForm
